;(function (angular) {
   'use strict'

   angular.module('azure.filters', [])
})(angular)
